/**
 * 에러 토스트 + LumirEditorError 정규화 리포터.
 * 모든 에러를 LumirEditorError 로 정규화해 콜백(opts.onError)+토스트+콘솔로 보낸다.
 * opts.showErrorToast === false 이면 토스트를 표시하지 않는다.
 */
import { LumirEditorError } from '../errors/lumir-error.js';

export function createErrorReporter(opts) {
  const toast = document.createElement('div');
  toast.className = 'lumir-error-toast';
  toast.style.display = 'none';
  let toastTimer = 0;
  const userOnError = typeof opts.onError === 'function' ? opts.onError : null;

  function showToast(msg) {
    if (opts.showErrorToast === false) return;
    toast.textContent = msg;
    toast.style.display = 'block';
    if (toastTimer) clearTimeout(toastTimer);
    toastTimer = setTimeout(() => {
      toast.style.display = 'none';
    }, 4000);
  }

  function onError(err, code) {
    const e =
      err instanceof LumirEditorError
        ? err
        : LumirEditorError.fromError(
            err instanceof Error ? err : new Error(String(err)),
            code,
          );
    try {
      console.error(e);
    } catch (_) {}
    showToast(e.getUserMessage());
    if (userOnError) {
      try {
        userOnError(e);
      } catch (_) {}
    }
  }

  function destroy() {
    if (toastTimer) clearTimeout(toastTimer);
    if (toast.parentNode) toast.parentNode.removeChild(toast);
  }

  return { toastEl: toast, showToast, onError, destroy };
}
